import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useGoogleTranslate } from '../../../Hooks/useGoogleTranslate';
import { usePageTitle } from '../../../Hooks/usePageTitle';
import contactUsImg from '../../../assets/images/contact-us.png';
import faqImg from '../../../assets/images/faq.png';
import privacyPolicyImg from '../../../assets/images/privacy-policy.png';
import termsOfUseImg from '../../../assets/images/terms-of-use.png';
import shippingPolicyImg from '../../../assets/images/shipping-policy.png';
import refundPolicyImg from '../../../assets/images/refund-policy.png';
import heartDecor from '../../../assets/images/coin-store-figma/decor-heart.svg';
import './index.css';

const HelpCenter = () => {
  const pageTitle = useGoogleTranslate('Help Center');
  const contactUs = useGoogleTranslate('Contact Us');
  const faq = useGoogleTranslate("FAQ's");
  const privacyPolicy = useGoogleTranslate('Privacy Policy');
  const termsOfUse = useGoogleTranslate('Terms Of Use');
  const shippingPolicy = useGoogleTranslate('Shipping Policy');
  const refundPolicy = useGoogleTranslate('Refund Policy');

  usePageTitle(pageTitle);

  const topRowCards = [
    { title: contactUs, image: contactUsImg, to: '/contact-us' },
    { title: faq, image: faqImg, to: '/' },
    { title: privacyPolicy, image: privacyPolicyImg, to: '/privacy-policy' },
    { title: termsOfUse, image: termsOfUseImg, to: '/terms-and-conditions' },
  ];

  const bottomRowCards = [
    { title: shippingPolicy, image: shippingPolicyImg, to: '/shipping-policy' },
    { title: refundPolicy, image: refundPolicyImg, to: '/refund-policy' },
  ];

  const renderCard = (card) => (
    <Col key={card.title} xs={12} sm={6} lg={3} className="help-figma-col d-flex">
      <Link to={card.to} className="d-block text-decoration-none w-100 help-figma-link">
        <div className="help-figma-card">
          <h6>{card.title}</h6>
          <img src={card.image} alt={card.title} className="help-figma-card-img" />
        </div>
      </Link>
    </Col>
  );

  return (
    <section className="help-figma-page">
      <span className="help-figma-decor help-figma-decor-ring-left-top" aria-hidden="true" />
      <span className="help-figma-decor help-figma-decor-ring-left-bottom" aria-hidden="true" />
      <span className="help-figma-decor help-figma-decor-ring-right-mid" aria-hidden="true" />
      <span className="help-figma-decor help-figma-decor-ring-right-top" aria-hidden="true" />
      <img src={heartDecor} alt="" className="help-figma-decor help-figma-decor-heart" aria-hidden="true" />

      <div className="help-figma-hero">
        <Container>
          <h1>{pageTitle}</h1>
        </Container>
      </div>

      <div className="help-figma-main">
        <Container className="help-figma-grid-wrap">
          <Row className="justify-content-center help-figma-row">{topRowCards.map(renderCard)}</Row>
          <Row className="justify-content-center help-figma-row help-figma-row-bottom">{bottomRowCards.map(renderCard)}</Row>
        </Container>
      </div>
    </section>
  );
};

export default HelpCenter;
